
import {FBRowOptions} from "./FBRow.Options";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {StoreBase, StoreDataType} from "shared/core/Store/StoreBase";
import {EventManager} from "shared/core/Events/EventManager";
import {LoadExtensionOptions} from "FormBuilder/Events/LoadExtensionOptions";
import {IconOrImage} from "FormBuilder/Fields/Core/Interfaces/IconOrImage";



export class FormBuilderOptions extends StoreBase{
    @StoreDataType(FBRowOptions)
    public Rows:FBRowOptions[];
    public Extensions:ExtensionBase[];
    @StoreDataType(String)
    public DynamicFieldTypes:string[];
    public Version=0;
    public Styles:string;
    public MapsApiKey:string;
    @StoreDataType(Object)
    public Icons:{Name:string,icon:any}[];
    protected LoadDefaultValues() {
        this.Rows=[];
        this.DynamicFieldTypes=[];
        this.Version=0;
        this.Styles='';
        this.Extensions=[];
        this.Icons=[];
        this.MapsApiKey='';
    }


    protected GetValueFromLoader(property:any, value: any): any {
        if(property=='Extensions')
            return value;
        return null;
    }
}

export  abstract class ExtensionBase extends StoreBase{
    Id:string;
    protected abstract LoadDefaultValues();
}

